import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { api, fileUrl } from "@/lib/api";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import JadwalSholatPublik from "@/pages/JadwalSholatPublik";
import KegiatanPublik from "@/pages/KegiatanPublik";
import KegiatanDetail from "@/pages/KegiatanDetail";
import Bergabung from "@/pages/Bergabung";
import Portal from "@/pages/Portal";
import SaranJamaah from "@/pages/admin/SaranJamaah";
import JamaahDetail from "@/pages/admin/JamaahDetail";
import PesanMasuk from "@/pages/admin/PesanMasuk";
import DonasiPublik from "@/pages/Donasi";
import PengumumanPublik from "@/pages/Pengumuman";
import PengumumanDetail from "@/pages/PengumumanDetail";
import KeuanganPublik from "@/pages/Keuangan";
import PengurusPublik from "@/pages/Pengurus";
import Kontak from "@/pages/Kontak";
import { JamaahProvider } from "@/context/JamaahContext";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import Keuangan from "@/pages/admin/Keuangan";
import Donasi from "@/pages/admin/Donasi";
import Kegiatan from "@/pages/admin/Kegiatan";
import Pengumuman from "@/pages/admin/Pengumuman";
import JamaahPage from "@/pages/admin/Jamaah";
import Inventaris from "@/pages/admin/Inventaris";
import Pengurus from "@/pages/admin/Pengurus";
import JadwalSholat from "@/pages/admin/JadwalSholat";
import ProfilMasjid from "@/pages/admin/ProfilMasjid";
import PengaturanWhatsApp from "@/pages/admin/PengaturanWhatsApp";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center text-emerald-900" data-testid="auth-loading">
        Memuat...
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  useEffect(() => {
    document.title = "Al-Iman Digital";
    api.get("/profile").then((r) => {
      if (!r.data?.logo_path) return;
      let link = document.querySelector("link[rel='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
      }
      link.href = fileUrl(r.data.logo_path);
    }).catch(() => {});
  }, []);

  return (
    <div className="App">
      <AuthProvider>
        <JamaahProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/jadwal-sholat" element={<JadwalSholatPublik />} />
            <Route path="/kegiatan" element={<KegiatanPublik />} />
            <Route path="/kegiatan/:id" element={<KegiatanDetail />} />
            <Route path="/bergabung" element={<Bergabung />} />
            <Route path="/donasi" element={<DonasiPublik />} />
            <Route path="/pengumuman" element={<PengumumanPublik />} />
            <Route path="/pengumuman/:id" element={<PengumumanDetail />} />
            <Route path="/keuangan" element={<KeuanganPublik />} />
            <Route path="/pengurus" element={<PengurusPublik />} />
            <Route path="/kontak" element={<Kontak />} />
            <Route path="/portal" element={<Portal />} />
            <Route
              path="/admin"
              element={
                <Protected>
                  <AdminLayout />
                </Protected>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="keuangan" element={<Keuangan />} />
              <Route path="donasi" element={<Donasi />} />
              <Route path="kegiatan" element={<Kegiatan />} />
              <Route path="pengumuman" element={<Pengumuman />} />
              <Route path="jamaah" element={<JamaahPage />} />
              <Route path="jamaah/:id" element={<JamaahDetail />} />
              <Route path="saran" element={<SaranJamaah />} />
              <Route path="pesan" element={<PesanMasuk />} />
              <Route path="inventaris" element={<Inventaris />} />
              <Route path="pengurus" element={<Pengurus />} />
              <Route path="jadwal-sholat" element={<JadwalSholat />} />
              <Route path="profil" element={<ProfilMasjid />} />
              <Route path="whatsapp" element={<PengaturanWhatsApp />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        </JamaahProvider>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
